<template>
  <v-container class="text-center">
    <h2 class="display-2 font-weight-bold mb-3">WELCOME</h2>

    <v-responsive class="mx-auto mb-8" width="56">
      <v-divider class="mb-1"></v-divider>
      <v-divider></v-divider>
    </v-responsive>

    <v-responsive class="mx-auto title font-weight-light" max-width="720">
      <v-alert
        class="body-1"
        border="left"
        color="accent"
        dark
        v-if="isSubscriptionActive"
      >Note: GroupBot is currently in beta, so there might be some hidden gremlins we've not caught yet!</v-alert>

      <v-alert
        class="body-1"
        border="left"
        color="warning"
        dark
        v-if="!isSubscriptionActive"
      >Your subscription is currently inactive, to continue using GroupBot please re-activate your subscription.</v-alert>
    </v-responsive>

    <v-avatar
      class="elevation-12 my-4"
      :color="$vuetify.theme.dark ? 'grey darken-1' : 'grey lighten-5'"
      size="120"
    >
      <v-img contain max-height="80%" :src="getLogo()"></v-img>
    </v-avatar>

    <v-responsive class="mx-auto" max-width="720">
      <p class="body-1 font-weight-light">If you do run into any gremlins, please contact support so that we can get those resolved as soon as possible.</p>
      <p class="body-1 font-weight-light">We'll also be adding some more amazing features soon!</p>
      
      <v-btn class="mt-6 mx-2" color="grey" href="https://docs.groupbot.app" outlined large>
        <span class="grey--text text--darken-1 font-weight-bold">Documentation</span>
      </v-btn>
      <v-btn class="mt-6 mx-2" color="grey" href="mailto:support@groupbot.app" outlined large>
        <span class="grey--text text--darken-1 font-weight-bold">Support</span>
      </v-btn>
    </v-responsive>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({}),
  mounted() {},
  computed: {
    ...mapGetters("apiAuth", ["user"]),
    isSubscriptionActive() {
      return (
        this.user &&
        this.user.account &&
        this.user.account.subscription &&
        this.user.account.subscription.active &&
        (this.user.account.subscription.paypal_subscription || this.user.account.subscription.free)
      );
    },
  },
  methods: {
    getLogo() {
      var images = require.context("@/assets/", false, /\.png$/);
      return images(
        this.$vuetify.theme.dark
          ? "./GroupBot-Logo-Dark.png"
          : "./GroupBot-Logo-Light.png"
      );
    },
  },
  watch: {},
};
</script>